/** The only module allowed to touch `console` (eslint no-console). Keeps a ring buffer for the error overlay. */
export type LogLevel = 'debug' | 'info' | 'warn' | 'error'

export interface LogEntry {
  level: LogLevel
  message: string
  data?: unknown
  time: number
}

const MAX_ENTRIES = 200
const entries: LogEntry[] = []

function write(level: LogLevel, message: string, data?: unknown): void {
  entries.push({ level, message, data, time: Date.now() })
  if (entries.length > MAX_ENTRIES) entries.shift()
  if (level === 'debug' && !import.meta.env.DEV) return
  const sink =
    level === 'debug' ? console.debug : level === 'info' ? console.info : level === 'warn' ? console.warn : console.error
  if (data === undefined) sink(`[eclipse] ${message}`)
  else sink(`[eclipse] ${message}`, data)
}

export const logger = {
  debug: (message: string, data?: unknown): void => write('debug', message, data),
  info: (message: string, data?: unknown): void => write('info', message, data),
  warn: (message: string, data?: unknown): void => write('warn', message, data),
  error: (message: string, data?: unknown): void => write('error', message, data),
  recent: (): readonly LogEntry[] => entries,
  clear: (): void => {
    entries.length = 0
  },
}
